import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	close: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	next: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tourHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tourBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tourHeadingIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tourBodyIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	close: {
		id: 'jql-builder-with-ai.natural-language-toggle.close',
		defaultMessage: 'Close',
		description:
			'Close button in the spotlight tour card shown for customers using AI issue search.',
	},
	next: {
		id: 'jql-builder-with-ai.natural-language-toggle.next',
		defaultMessage: 'Next',
		description:
			'Next button in the spotlight tour card shown for customers using AI issue search.',
	},
	tourHeading: {
		id: 'jql-builder-with-ai.natural-language-toggle.tour-heading',
		defaultMessage: 'Use AI to find issues faster',
		description:
			'Heading of the first spotlight tour card shown for customers using AI issue search.',
	},
	tourBody: {
		id: 'jql-builder-with-ai.natural-language-toggle.tour-body',
		defaultMessage:
			'Search for issues with Atlassian Intelligence instead of coming up with complex queries.',
		description: 'Body of the first spotlight tour card shown for customers using AI issue search.',
	},
	tourHeadingIssueTerminologyRefreshM4: {
		id: 'jql-builder-with-ai.natural-language-toggle.tour-heading-issue-terminology-refresh-m4',
		defaultMessage: 'Use AI to find work items faster',
		description:
			'Heading of the first spotlight tour card shown for customers using AI issue search.',
	},
	tourBodyIssueTerminologyRefreshM4: {
		id: 'jql-builder-with-ai.natural-language-toggle.tour-body-issue-terminology-refresh-m4',
		defaultMessage:
			'Search for work items with Atlassian Intelligence instead of coming up with complex queries.',
		description: 'Body of the first spotlight tour card shown for customers using AI issue search.',
	},
});
export default messages;
